import { render, staticRenderFns } from "./ModalLink.vue?vue&type=template&id=16782a62&"
import script from "./ModalLink.vue?vue&type=script&lang=js&"
export * from "./ModalLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports